/**
 * Author：brand
 * Creation Time：2019-05-11 10:43
 * Email：brandhuang@qq.com
 */

import * as auth from './modules/auth'
import * as common from './modules/common'
import * as user from './modules/user'
import * as settingSys from './modules/setting/setting-system'
import * as settingAdvanced from './modules/setting/setting-advanced'
import * as settingOnline from './modules/setting/setting-online'
import * as settingJoin from './modules/setting/setting-join'
import * as serviceAll from './modules/service/service-all'
import * as serviceRole from './modules/service/service-role'
import * as serviceReport from './modules/service/service-report'
import * as businessTeam from './modules/business/business'
import * as history from './modules/history/history'
import * as overview from './modules/report/overview'
import * as leavewords from './modules/report/leavewords'
import * as service from './modules/report/service'
import * as website from './modules/report/website'
import * as Index from './modules/index/index'
import * as Order from './modules/order/index'
import * as workOrder from './modules/workOrder/workorder'
import * as aiCustomer from './modules/aiCustomer/ai-customer'


export default {
  ...common,
  ...auth,
  ...user,
  ...settingSys,
  ...settingAdvanced,
  ...settingOnline,
  ...serviceAll,
  ...serviceRole,
  ...serviceReport,
  ...businessTeam,
  ...settingJoin,
  ...history,
  ...overview,
  ...leavewords,
  ...service,
  ...website,
  ...Index,
  ...Order,
  ...workOrder,
  ...aiCustomer,
}
